<template>
<div class="bg-light p-3 mb-2">
    <b-badge class="float-left">{{resultIndex+1}}</b-badge>
    <b-badge class="float-left ml-2" :variant="resultData.analysis.site.type && resultData.analysis.site['type'] == 'NOT MATCHED' ? 'danger' : 'success'">{{resultData.analysis.site.type && resultData.analysis.site['type'] == 'NOT MATCHED' ? 'Non Match' : resultData.analysis.site['type']+' Site'}}</b-badge>
    <!-- menu buttons -->
    <MenuButtons :keywords="keywords" :resultData="resultData" :collapse="collapse" :resultIndex="resultIndex" :age="checkDate()" :filtered="filtered" v-on:collapse-field="collapse=!collapse" :isBing="false" />
    <!-- input content -->
    <b-collapse id="collapse-1" v-model="collapse">
        <b-tabs>
            <b-tab title="Overview">
                <b-row class="p-3">
                    <b-col cols="12" class="text-left">
                        <!-- <p>{{resultData.title}}</p> -->
                        <a :href="resultData.link" target="_blank">{{resultData.title}}</a>
                        <p>
                            <strong>{{resultData.displayLink}}</strong>
                        </p>
                        <p>
                            <strong>Date Published:</strong>

                            {{checkDate()}}
                        </p>
                        <p>
                            <strong>Snippet:</strong>
                        </p>
                        <p>{{ highLightText(resultData.snippet)}}</p>
                        
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Keyword Match Count">
                <b-card title="Keyword Match" class="mb-2">
                    <b-card-text v-if="resultData.analysis.searchKeywordCount">
                        
                        <span v-for="(keyword,index) in resultData.analysis.searchKeywordCount" :key="index">
                            <b-badge  :variant="keyword.count > 0 ? 'danger' : 'success'" class="mr-2" :key="index">{{keyword.keyword}} ({{keyword.count}})</b-badge>
                        </span>
                    </b-card-text>

                </b-card>
            </b-tab>
            <b-tab title="Page Text">
                <b-card title="Page Text" class="mb-2" v-if="resultData.analysis.pageText">
                    <b-card-text>
                        <p v-html="sanitizeHtml(resultData.analysis.pageText && JSON.parse(resultData.analysis.pageTextWIthKeyWordHighlighted))"></p>
                    </b-card-text>
                </b-card>
            </b-tab>
            <b-tab title="URL">
                <b-card title="URL" class="mb-2">
                    <b-card-text v-if="resultData.analysis.site && resultData.analysis.site.type">
                        <b-badge variant="primary">{{resultData.analysis.site && resultData.analysis.site.type}}</b-badge>&nbsp;<b-badge variant="primary">{{resultData.analysis.site && resultData.analysis.site.language}}</b-badge>&nbsp;<b-badge variant="primary">{{resultData.analysis.site && resultData.analysis.site.country}}</b-badge>
                    </b-card-text>
                    
                    <b-card-text v-if="resultData.analysis.site && resultData.analysis.site.site_name">
                        <b-badge variant="primary">{{resultData.analysis.site && resultData.analysis.site.site_name}}</b-badge>
                    </b-card-text>
                    <b-card-text>
                        {{resultData && resultData.analysis && resultData.analysis.url}}
                    </b-card-text>

                </b-card>
                
                
                
                <!-- <b-card title="Page Words" class="mb-2">
                    <b-card-text>
                        <p v-html="resultData.analysis.pageWords"></p>
                    </b-card-text>

                </b-card> -->
                <!-- <b-card title="Page Word With Count" class="mb-2">
                    <b-card-text>
                        <p v-html="resultData.analysis.pageWordsCounts"></p>
                        
                    </b-card-text>

                </b-card> -->

            </b-tab>

            <b-tab title="Article Score Summary">
                <b-card title="Article Score Summary" class="mb-2" >
                    <b-card-text>
                        <p>Site Type: <span>{{resultData.analysis.score && resultData.analysis.score.siteType || 0}}</span></p>
                    </b-card-text>
                    <b-card-text>
                        <p>Age Of Article: <span>{{resultData.analysis.score && resultData.analysis.score.ageOfArticle || 0}}</span></p>
                    </b-card-text>
                    <b-card-text>
                        <p>Keyword Match: <span>{{resultData.analysis.score && resultData.analysis.score.keywordMatchCount || 0}}</span></p>
                    </b-card-text>

                </b-card>
            </b-tab>
            <b-tab title="NLP Match" v-if="resultData.analysis.nlp && resultData.analysis.nlp.keywords">
                <b-row>
                    <b-col v-for="(keyword,index) in resultData.analysis.nlp.keywords" :key="index" cols="4">
                        <b-card :title="keyword.keyword">
                            <b-card-text>
                                Phrase: {{keyword.phrase}}
                            </b-card-text>

                    </b-card>
                    
                    </b-col>
                </b-row>
                    
                
            </b-tab>
            <b-tab title="Schema" class="text-left">
                <pre>
                    {{resultData}}
                </pre>
            </b-tab>
        </b-tabs>

    </b-collapse>
</div>
</template>

<script>
import {
    required
} from "vuelidate/lib/validators";
import MenuButtons from "./menuButtons";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import {
    mapGetters,
    mapState
} from "vuex";
import {
    EventBus
} from "@/event-bus.js";
import moment from "moment";

export default {
    name: "SearchResult",
    components: {
        MenuButtons
    },
    data() {
        return {
            collapse: false,
            date: null
        };
    },
    created() {},
    mounted() {
        
    },
    validations: {},
    computed: {
        ...mapGetters([]),
        ...mapState(["toggleAllCoppalse"])
    },
    watch: {
        toggleAllCoppalse(value) {
            this.collapse = value;
        }
    },
    methods: {
        sanitizeHtml,
        highLightText(article){

            if(article && this.keywords)
            {
let phrase = article;
       
            this.keywords.forEach(keyword =>{
                        phrase = phrase.replace(keyword, '<span class="badge badge-danger">'+keyword+'</span>')
            })
            
             return phrase; 
            }
           return 'No Text Is available';
        },
        getDateFromArticle(article) {
            let snippet = article.snippet;
            let data = snippet.split("...");
            return data[0];
        },
        checkDate() {
            this.date = this.getDateFromArticle(this.$props.resultData);
            moment.updateLocale(moment.locale(), {
                invalidDate: "Date of article is unknown"
            });
            return moment(String(this.date)).format("MMM DD, YYYY");
        },
       
       
        age(value) {
            
            let localeData = moment.updateLocale("en", {
                relativeTime: {
                    future: "in %s",
                    past: "%s ago",
                    s: "hello, a few seconds",
                    ss: "%d seconds",
                    m: "a minute",
                    mm: "%d minutes",
                    h: "an hour",
                    hh: "%d hours",
                    d: "a day",
                    dd: "%d days",
                    M: "a month",
                    MM: "%d months",
                    y: "a year",
                    yy: "%d years"
                }
            });
            //return moment(value).fromNow();

            return moment(value).fromNow();
        }
    },
    props: {
        resultData: Object,
        resultIndex: Number,
        keywords: Array,
        filtered: Boolean
    }
};
</script>
